module.exports = __webpack_public_path__ + "static/media/icon-delete-circle-red.f3fc66ee.svg";